import { Postulacion } from '../../../../core/models/postulaciones.models';

export function construirCsvPatrocinio(
  postulaciones: Postulacion[],
  obtenerEstado: (item: Postulacion) => string,
  obtenerIdProyecto: (item: Postulacion) => string
): string {
  const headers = ['ID Postulacion', 'Concurso', 'Subdireccion', 'ID Proyecto', 'Folio', 'Estado'];

  const rows = postulaciones.map((item) => [
    item.idPostulacion,
    item.concurso,
    item.subdireccion,
    obtenerIdProyecto(item),
    item.folio,
    obtenerEstado(item),
  ]);

  return [headers, ...rows]
    .map((line) => line.map((cell) => `"${String(cell).replaceAll('"', '""')}"`).join(','))
    .join('\n');
}

export function construirNombreDescargaPatrocinio(fechaIso: string): string {
  return `historial-patrocinio-${fechaIso}.csv`;
}
